
export const LOAD_REMOTE_DEVICE_DATA_IN_PROGRESS = "LOAD_REMOTE_DEVICE_DATA_IN_PROGRESS";
export const loadRemoteDeviceDataInProgress = () => ({
  type: LOAD_REMOTE_DEVICE_DATA_IN_PROGRESS,
});

export const LOAD_REMOTE_DEVICE_DATA_SUCCESS = "LOAD_REMOTE_DEVICE_DATA_SUCCESS";
export const loadRemoteDeviceDataSuccess = (data) => ({
  type: LOAD_REMOTE_DEVICE_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_REMOTE_DEVICE_DATA_FAILURE = "LOAD_REMOTE_DEVICE_DATA_FAILURE";
export const loadRemoteDeviceDataFailure = () => ({
  type: LOAD_REMOTE_DEVICE_DATA_FAILURE,
});

export const REMOTE_DEVICE_OPERATION_COMPLETED = "REMOTE_DEVICE_OPERATION_COMPLETED";
export const remoteDeviceOperationCompleted = () => ({
  type: REMOTE_DEVICE_OPERATION_COMPLETED,
});



